document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.hotel-swiper').forEach(function (swiperObject) {
        new Swiper(swiperObject.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            grabCursor: true,
            speed: 700,
            pagination: {
                el: swiperObject.querySelector('.swiper-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: swiperObject.querySelector('.swiper-button-next'),
                prevEl: swiperObject.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesOffsetBefore: 40,
                    slidesOffsetAfter: 40,
                },
                1580: {
                    slidesOffsetBefore: 80,
                    slidesOffsetAfter: 80,
                },
            }
        });
    });
});

//# sourceMappingURL=swiper-hotel.js.map
